import styled from "styled-components";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import TabBar from "../../../../components/TabBar";
import MessageDetails from "../MessageDetails";
import MessageLinks from "../MessageLinks";

const StyledMessageRightPane = styled.div`
	margin-left: 30px;
	width: 337px;
`;

function MessageRightPane(props) {

	const {messages, selectedMessage, isAddMode, setIsAddMode, refreshMessagesCallback} = props;

    let defaultPath = '/admin/messages/';

    let defaultTabPath = 'main';
    let {subTabPath} = useParams();

    let tabs = [
        {text: 'Main details', path: 'main'},
        {text: 'Message hyperlinks', path: 'hyperlinks'},
    ];

	useEffect(() => {
	});

    return (
        <StyledMessageRightPane>
			<TabBar tabs={tabs} defaultPath={defaultPath} selectedSubTabPath={subTabPath ? subTabPath : defaultTabPath} disabled={isAddMode}></TabBar>
            {(!subTabPath || subTabPath === '' || subTabPath === 'main') && 
                <MessageDetails messages={messages} selectedMessage={selectedMessage} isAddMode={isAddMode} setIsAddMode={(mode) => {setIsAddMode(mode)}} refreshMessagesCallback={refreshMessagesCallback} {...props}></MessageDetails>
            }
            {subTabPath === 'hyperlinks' &&
                <MessageLinks selectedMessage={selectedMessage} {...props}></MessageLinks>
            }
		</StyledMessageRightPane>
    )
}

export default MessageRightPane;